<template>
    <SensorDetailDialog
        :isShowDetail.sync="detailIsShow"
        :title="detailTitle"
        :baseMsg="baseMsg"
        :detailObj="detailObj"
        :deviceType="newDeviceType"
        :deviceProperty="deviceProperty"
        :detailLoading="detailLoading"
        :detailRuleObj="detailRuleObj"
        :detailNetObj="detailNetObj"
        v-bind="$attrs"
    ></SensorDetailDialog>
</template>

<script>
import SensorDetailDialog from './component/SensorDetailDialog.vue';
import { sensorGetSensorDetailInfo } from '@/api/modules/sensor.js';
import bus from '@/utils/bus';
export default {
    props: ['id', 'name', 'show'],
    components: {
        SensorDetailDialog
    },
    data() {
        return {
            baseMsg: [
                {
                    text: 'public.belong',
                    key: 'url',
                    content: ''
                },
                {
                    text: $t('integration.monitoring_point'),
                    key: 'carrierName',
                    content: ''
                },
                {
                    text: $t('integration.sensor_number'),
                    key: 'tagId',
                    content: ''
                },
                {
                    text: $t('integration.sensor_type'),
                    key: 'type',
                    content: ''
                },

                {
                    text: $t('integration.sensor_status'),
                    key: 'status',
                    content: ''
                },
                {
                    text: 'device.config_status',
                    key: 'configStatus',
                    content: ''
                },
                {
                    text: 'public.table_create_time',
                    key: 'createTime',
                    content: ''
                },
                {
                    key: 'nickname',
                    text: 'device.nickname',
                    content: ''
                },
                {
                    key: 'description',
                    text: $t('public.table_desc'),
                    content: ''
                },
              {
                key: 'location',
                text: $t('public.location_desc'),
                content: ''
              },
              {
                key: 'group',
                text: $t('public.group_desc'),
                content: ''
              }
            ],
            detailRuleObj: [
                {
                    key: 'collectInterval',
                    text: $t('integration.acquisition_interval'),
                    isBool: true
                },
                {
                    key: 'exCollectInterval',
                    text: $t('integration.abnormal_collection_interval'),
                    isBool: true
                },
                {
                    key: 'tempCollectInterval',
                    text: $t('integration.temperature_acquisition_interval'),
                    isBool: true
                },
                {
                    key: 'tempChange',
                    text: $t('integration.temperature_change_threshold'),
                    isBool: true
                },
                {
                    key: 'tempMaxReport',
                    text: $t('integration.maximum_temperature_reporting_interval'),
                    isBool: true
                },
                {
                    key: 'tempMinReport',
                    text: $t('integration.minimum_temperature_reporting_interval'),
                    isBool: true
                },

                {
                    key: 'humCollectInterval',
                    text: $t('integration.humidity_collection_interval'),
                    isBool: true
                },
                {
                    key: 'humChange',
                    text: $t('integration.humidity_change_threshold'),
                    isBool: true
                },
                {
                    key: 'humMaxReport',
                    text: $t('integration.maximum_humidity_reporting_interval'),
                    isBool: true
                },
                {
                    key: 'humMinReport',
                    text: $t('integration.humidity_minimum_reporting_interval'),
                    isBool: true
                }
            ],
            detailNetObj: [
                {
                    key: 'extPanId',
                    text: 'Ext Pan ID',
                    isBool: true
                },
                {
                    key: 'channelPage',
                    text: 'Join Attemp',
                    isBool: true
                },
                {
                    key: 'transmitPower',
                    text: 'device.transmit_power',
                    isBool: true
                },
                {
                    key: 'channelMask',
                    text: 'device.channel_mask',
                    isBool: true
                },
                {
                    key: 'inNetInterval',
                    text: 'device.in_net_interval',
                    isBool: true
                },
                {
                    key: 'devEui',
                    text: 'DevEUI',
                    isBool: true
                },
                {
                    key: 'appEui',
                    text: 'AppEUI',
                    isBool: true
                },
                {
                    key: 'appKey',
                    text: 'AppKey',
                    isBool: true
                }
            ],
            detailObj: null,
            newDeviceType: {},
            deviceProperty: {},
            detailLoading: false,
            detailIsShow: false,
            detailTitle: ''
        };
    },
    watch: {
        detailIsShow(newval) {
            this.$emit('update:show', newval);
        }
    },
    methods: {
        detailFn(id, name) {
            // console.log('row===>', row);
            this.detailTitle = `[${name}]` + this.$t('public.details');
            this.detailIsShow = true;
            this.detailLoading = true;
            sensorGetSensorDetailInfo(id)
                .then(({ result, state }) => {
                    result.sensor.pictureBase64 = result.sensor.pictureBase64 || result.deviceType.pictureBase64;
                    this.detailObj = result.sensor;
                    this.newDeviceType = result.deviceType;
                    this.deviceProperty = result.deviceProperty || {};
                    const { sensor, appConfig, netConfig } = result;
                    // 基本的数据
                    sensor.create_time = this.$timetransition(sensor.create_time);
                    this.baseMsg.forEach(item => {
                      console.log('item->',item);
                        for (let newKey in sensor) {
                            if (item.key === newKey){
                              item['content'] = sensor[newKey]
                            }
                            if (item.key === 'url') {
                                item['content'] = `${sensor.fullPath}/${sensor.carrierName}`;
                            }
                        }
                    });
                    this.getGenerValueFn(this.detailRuleObj, appConfig);
                    this.getGenerValueFn(this.detailNetObj, netConfig);
                })
                .finally(() => {
                    this.detailLoading = false;
                });
        },
        getGenerValueFn(array = [], obj) {
            array.forEach(item => {
                item.content = '';
                for (let newKey in obj) {
                    item.key === newKey ? (item['content'] = obj[newKey]) : null;
                }
            });
        }
    },
    mounted() {
        bus.$on('sensorParams', (id, name) => {
          console.log('sensorParams--------------')
            this.detailFn(id, name);
            this.detailIsShow = true;
        });
    },
    beforeDestroy() {
        bus.$off('sensorParams');
    }
};
</script>

<style></style>
